import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { serverURL } from 'config';

let link = document.querySelector("link[rel~='icon']");

if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
}
if (serverURL.includes("test.")) {
    link.href = `/red.ico`;
} else if (serverURL.includes("pp.")) {
    link.href = `/orange.ico`;
} else if (serverURL.includes("localhost")) {
    link.href = `/red.ico`;
}

// Check for 502 Bad Gateway error page before React loads
// This handles cases where nginx returns a 502 HTML page
const checkFor502Error = () => {
  // Check if the page content indicates a 502 error
  const bodyText = document.body?.innerText || document.body?.textContent || '';
  const titleText = document.title || '';
  
  if (bodyText.includes('502 Bad Gateway') || 
      bodyText.includes('502') || 
      titleText.includes('502') ||
      document.body?.querySelector('body')?.innerText?.includes('502')) {
    // Redirect to no-connection page
    const currentPath = window.location.pathname;
    if (currentPath !== '/no-connection') {
      window.location.href = '/no-connection';
      return true; // Prevent React from rendering
    }
  }
  return false;
};

// Run check immediately
if (!checkFor502Error()) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
